const PRICINGOVERVIEW = {
  TOTAL_PAYABLE: "Total Payable Amount",
  CURRENCY: "Rs.",
  DISCOUNT_CURRENCY: "- Rs.",
  OVERVIEW: "Overview",
  TEXT: {
    subtotal: "Subtotal",
    discounts: "Discount",
    tax: "GST",
    shippingCost: "Delivery Charges",
    loyalty: "Loyalty",
    netAmount: "Net Amount",
  },
  TOTAL: {
    total: "Total",
  },
};

export default PRICINGOVERVIEW;



// WEBPACK FOOTER //
// ./src/constants/pricingOverview.js